<template>
  <div class="titleText">

    <div>
      <img src="../assets/images/backGround3.jpg" alt class="backGround" />
    </div>

    <div>
      <p alt class="textStyle2">{{$t('turn.account')}}：{{ this.userInformationData.user }}</p>
      <p alt class="textStyle3">{{$t('turn.count')}}：{{ this.count }}</p>
    </div>

    <div>
      <img src="../assets/images/turnplate-bg.png" :class="[start]" />
      <!-- <img src="../assets/images/draw_wheel.png" :class="[start]" /> -->
    </div>

    <div alt class="picture" v-show="showFile">
      <img :src="require('../assets/images/' + this.file + '.jpg')">
    </div>

    <div class="wheel-wrapper">
      <div class="wheel-pointer" @click="onClickRotate" :style="{ cursor: 'pointer' }">
        <img src="../assets/images/go2.png" class="startText"/>
      </div>

      <div class="wheel-bg" :style="`transform: rotate(${wheelDeg}deg)`">
        <div class="prize-list">
          <div class="prize-item-wrapper" v-for="(item, index) in awardsListForm" :key="index">
            <div class="prize-item" :style="`transform: rotate(${(360 / awardsSize) * index}deg) `">
              <p>{{ item.prizeName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div>
      <input type="button" value="抽獎紀錄" name="按鈕名稱" atl class="inputButton" :style="{ cursor: 'pointer' }" @click="getWinningRecord(currentPage)" :disabled="button_disabled">
    </div> -->
    <div>
      <el-button atl class="inputButton" style="width:200px" @click="getWinningRecord(currentPage)" :disabled="button_disabled">{{$t('turn.history')}}</el-button>
    </div>

    <div>
      <ul class="awardMsg">
        <img src="../assets/images/name.png" alt class="notice" />
        <p style="color:white">{{ show ? msg : '' }}</p>
      </ul>
    </div>

    <!-- //抽獎紀錄 -->
    <!-- <div >
      <ul class="awardListMsg">
        <p style="color:white"> 本次抽獎紀錄:</p>
      </ul>
    </div>
    <div  v-for="(item, index) in awardListMsg" :key="index">
      <ul class="awardListMsg">
        <p style="color:white">{{ item}}</p>
      </ul>
    </div> -->
    <el-dialog :visible.sync="dialogTableVisible" :append-to-body='true' width="550px">
      <el-table id="tb1" :data="winningData" align="center">
        <el-table-column property="drawTime" align="center" :label="$t('turn.time')" width="180"></el-table-column>
        <el-table-column property="award" align="center" :label="$t('turn.prize')" width="170"></el-table-column>
        <el-table-column property="status" align="center" :label="$t('turn.status')" width="110"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="page_size"
        layout="total, prev, pager, next"
        :total=total>
      </el-pagination>
    </el-dialog>

  </div>
</template>
<script>
import { Toast } from 'vant';
import md5 from "js-md5";
import { Loading } from 'element-ui';

export default {
  name: "index",
  data() {
    return {
      //
      userInformationData: {
        user: "",
        token: "",
        platform: ""
      },
      //get user
      result: '',
      //getUserReport
      count: null,
      start: 'turnplate',
      awardListMsg:[],
      list:0,
      awardsSize: 0,
      msg: '',
      show: false,
      freeze: false,
      rolling: false,
      wheelDeg: 0,
      awardsListForm: [{ prizeName: "1獎" }, { prizeName: "2獎" }, { prizeName: "3獎" }, { prizeName: "4獎" }, { prizeName: "5獎" }],
      winningData: [],
      file:'award0',
      showFile: false,
      button_disabled: false,
      dialogTableVisible: false,
      test1: [],
      currentPage: 1,
      total: 0,
      page_size: 10,
      user: '',
      token: ''
    };
  },
  computed: {


  },
  created() {
    // this.switchLang()
    // this.checkUserToken(this.$route.query.user, this.$route.query.token, this.$route.query.p)
    // // this.getUserReport()
    // this.getMemberReport()
    // this.getAwardsList()
  },
  mounted() {

  },
  methods: {
    switchLang() {
      if (this.$route.query.p == 18 || this.$route.query.p == 168) {
        this.$i18n.locale = 'en'
      }else{
        this.$i18n.locale = 'zh-tw'
      }
    },
    checkUserToken(user, token, platform) {
      this.userInformationData.user = user
      this.userInformationData.token = token
      this.userInformationData.platform = platform
    },
    handleSizeChange(val) {
      this.getWinningRecord(val)
    },
    handleCurrentChange(val) {
      this.getWinningRecord(val)
    },
    //計算獎項的總數
    async getAwardsList() {
       await fetch('/api/getAwardsList',
        { method: "GET" }).then(res => res.json()).then(res => {
        for (var i = 0; i < res.data.length; i++) {
          this.awardsListForm[i] = this.$t('awards.'+i)
          // this.awardsListForm[i] = res.data[i].award
        }
        this.awardsSize = res.data.length
      })
    },

    async getWinning() {
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform
      }
      await fetch('/api/draw',
        { method: "POST" , body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
        if (res.data != 404) {
          this.roll(res.data);
        }
      })
    },

    getWinningRecord(page) {
      let loadingInstance = Loading.service({background:  'rgba(0, 0, 0, 0.6)' });
      this.dialogTableVisible = true
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform,
        pageNum: page-1
      }
      fetch('/api/getWinning',
        { method: "POST" , body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
              res.data[index].drawTime = this.formatDate(res.data[index].drawTime)
              res.data[index].award = this.$t('awards.'+res.data[index].award)
              // res.data[index].award = this.awardsListForm[res.data[index].award]
              if (res.data[index].status == "0") {
                res.data[index].status = this.$t('turn.unpay')
              }else{
                res.data[index].status = this.$t('turn.payed')
              }
            }
          }
          this.total = res.total
          this.winningData = res.data
          loadingInstance.close();
      })
    },

    async getMemberReport() {
      let loadingInstance = Loading.service();
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform
      }
      await fetch('/api/getMemberReport',
        { method: "POST" , body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == 0) {
            if (res.data) {
              this.count = Math.floor(res.data.count)
            }
          }else{
            this.$message.error(res.data+this.$t('turn.contact'));
            this.count = 0
          }
          loadingInstance.close();
      })
    },
    onClickRotate() {
      this.start = 'run'
      // this.button_disabled = true
      // this.show = false //會清空中獎訊息欄
      //如果次數為0 不得抽獎
      if (this.count === 0 || this.count === null) {
        this.show = true
        this.msg = this.$t('turn.zero')
            // this.$message.error('抽獎次數為0');
        this.start = 'turnplate'
        // 如果尚在抽獎中不執行任何動作
      } else {
        if (this.rolling) {
          this.show = true
          this.msg = this.$t('turn.drawing')
          return;
        }
        this.getWinning()
      }
    },
    roll(result) {
      this.button_disabled = true
      this.rolling = true;
      const { wheelDeg, awardsListForm } = this;
      this.wheelDeg =
        wheelDeg -
        wheelDeg % 360 +
        6 * 360 +
        (360 - 360 / this.awardsSize * result);

      setTimeout(() => {
        this.rolling = false;
        this.msg = this.$t('turn.congratulations') + awardsListForm[result];
        this.show = true
        this.count = this.count - 1
        const number = this.list+1

        this.awardListMsg[this.list]='第' +number+'次抽中: '+awardsListForm[result]
        this.start = 'turnplate'
        this.list = this.list+1
        this.file = 'award'+result
        this.showFile=false
        this.button_disabled = false

      }, 4500);

    },
    formatDate(value) {
      value = parseInt(value) *1000
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  watch: {
    prizeNumber() {
      this.freeze = true;
      this.wheelDeg = 0;

      setTimeout(() => {
        this.freeze = false;
      }, 0);
    }
  }
};
//

</script>
<style  scoped>
html {
  background: #dd7c7d;
}

.inputButton {
  position: relative;
  top: 1.3rem;
  left: 0rem;
  width: 150px;
  height:75px;
  border: 0;
  background-color: #003C9D;
  color: #fff;
  border-radius: 10px;
  font-size: 25px;
  z-index: 999;

}

.picture{
  position: absolute;
  top:4rem;
  right:2rem;
  z-index: 999;
}

.backColor {
  background-color: #000;
}

.wheel-wrapper {
  width: 500px;
  height: 500px;
  position: absolute;
  top: 30rem;
  right: 30rem;
  transform: translate(-50%, -50%);
}

.wheel-pointer {
  width: 100px;
  height: 100px;
  border-radius: 1000px;
  background: yellow;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  z-index: 10;
  cursor: pointer;
}

.after {
  content: "";
  position: absolute;
  top: -32px;
  left: 50%;
  border-width: 0 8px 40px;
  border-style: solid;
  border-color: transparent transparent yellow;
  transform: translateX(-50%);
}

.wheel-bg {
  width: 100%;
  height: 100%;
  border-radius: 1000px;
  overflow: hidden;
  transition: transform 5s ease-in-out;
  background: pink;
}

.freeze {
  transition: none;
  background: red;
}


.prize-list {
  width: 200%;
  height: 150%;
  position: relative;
  text-align: center;
  top: 0.5rem;
  right: 2.5rem
}

.prize-item-wrapper {
  position: absolute;
  top: 35px;
  left: 28.5%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;

}

.turnColor {
  background-color: #000;
}

.prize-item {
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  font-size: 30px;
  color: white;

}

.prize-name {
  padding: 16px 0;
}


.titleText {
  background-color: #000;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 4.1rem;
}

.textStyle2 {
  position: absolute;
  color: white;
  font-size: 48px;
  top: 1rem
}

.textStyle3 {
  position: absolute;
  color: white;
  font-size: 48px;
  top: 1rem;
  left: 48rem
}

.startText {
  position: absolute;
  color: black;
  font-size: 40px;
  top: -4rem;
  right: -2rem
}

.backGround {
  position: absolute;
  top: 0rem;
  right: 0rem;
  width: 100%;
  height: 100%;
  z-index: -2
}

.notice {
  position: absolute;
  top: 1rem;
  left: 0.55rem;
  background-color: white;
  z-index: 2;

}

.awardMsg {
  position: relative;
  background: url("../assets/images/phone.png") center top no-repeat;
  background-size: 100%;
  width: 100%;
  height: 3.74rem;
  line-height: 3.74rem;
  font-size: 2.35rem;
  overflow: hidden;
  text-align: center;
  letter-spacing: 0.03rem;
  top: -3.1rem;
  z-index: 1;

}

.awardListMsg {
  position: relative;
  background: url("../assets/images/phone.png") center top no-repeat;
  background-size: 100%;
  width: 30%;
  height: 500%;
  line-height: 0.74rem;
  font-size: 0.35rem;
  overflow: hidden;
  text-align: center;
  letter-spacing: 0.03rem;
  top: -3.1rem;
  z-index: 1;

}

.window {
  position: absolute;
  top: 1rem;
  left: 1.5rem;
  width: 1300px;
  height: 80px;
  background: grey;
  font-size: 30px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  z-index: 999
}

.button {
  position: absolute;
  top: 8rem;
  right: 14rem;
  width: 300px;
  height: 80px;
  background: purple;
  font-size: 50px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  z-index: 2
}

.turnplate {
  position: absolute;
  top: 11rem;
  right: 42.5rem;
  width: 600px;
  height: 600px;
  animation: rotate360 3s linear both reverse infinite;

}

.run {
  position: absolute;
  top: 11rem;
  right: 42.5rem;
  width: 600px;
  height: 600px;
  /* animation: rotate360 10s linear both reverse infinite; */

}

.titleText el-dialog table {
	border: 0;
}

.titleText el-dialog table tr {
	border-bottom: 1px solid
}

.titleText el-dialog table tr:nth-child(odd) {
	background: none
}

.titleText el-dialog table tr td,
.titleText el-dialog table tr th {
	border: 0
}


@keyframes rotate360 {
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/turn.vue